module.exports = "/images/CzechRepublic.png?b60ef6bbaf3e5249bce6aa31ae8f1e38";